// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"1411":"9a3ba646e0060601","3969":"88cc307938b7852c","7337":"f1ede546df3bd613","8445":"506568f878839125"}[chunkId] + ".js";
};